import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5eea0fb3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bottom-wrapper" }

import { onMounted } from 'vue'
import { useRouter } from 'vue-router'

import Tabs from '@/popup/components/views/Home/Profile/Tabs.vue'
import EmptyTab from '@/popup/components/views/Home/Profile/EmptyTab.vue'
import ControllersPanel from '@/popup/components/views/Home/Profile/ControllersPanel.vue'
import AuthenticatedApps from '@/popup/components/views/Home/Profile/AuthenticatedApps.vue'
import ProfileCard from '@/popup/components/views/Home/Profile/ProfileCard.vue'
import Activity from '@/popup/components/views/Home/Profile/Activity.vue'
import { useUIStore } from '@/popup/store/UIStore'
import { useApprovalsStore } from '@/popup/store/ApprovalsStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'Profile',
  setup(__props) {

const uiStore = useUIStore()
const router = useRouter()
const approvalsStore = useApprovalsStore()

onMounted(async () => {
  if (approvalsStore.nonStashedApprovals.length > 0) {
    const approval = approvalsStore.nonStashedApprovals[0]
    ;({
      transaction: () => router.push(`/transaction/${approval.id}`),
      sign: () => router.push(`/sign/${approval.id}`),
      requestAccounts: () => router.push(`/web3-auth/${approval.id}`),
      import: () => router.push(`/qrcode/import-profile-dapp/${approval.id}`),
      relayer: () => router.push(`/relayer-auth/${approval.id}`),
      switchNetwork: () => router.push(`/network-switch/${approval.id}`),
      addNetwork: () => router.push(`/settings/network/${approval.id}`),
      createAddress: () => router.push(`/create-address/${approval.id}`),
    })[approval.type]()
    return
  }

  if (uiStore.isPopup) {
    return window.close()
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ProfileCard),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Tabs),
      _createElementVNode("div", {
        class: _normalizeClass(["tab-content-wrapper", `${!!_unref(uiStore).toast ? 'custom-height' : ''}`])
      }, [
        _createVNode(EmptyTab),
        _createVNode(AuthenticatedApps),
        _createVNode(ControllersPanel),
        _createVNode(Activity)
      ], 2 /* CLASS */)
    ])
  ]))
}
}

})